import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_checking_sample_hdr_RowClass} from '../../../dbschema';

export class ClaimCycleCheckingSampleHdrContainerModel extends BaseContainerModel {
  bl_aat_claim_cycle_checking_sample_hdr: bl_aat_claim_cycle_checking_sample_hdr_RowClass = new bl_aat_claim_cycle_checking_sample_hdr_RowClass();
}
